import { uuid } from "@/interfaces";
import { api } from "@/lib/api";
import { ApiRequestError, type ChatContact, type ChatMember, type ChatMemberAddition, type ChatRoom as ApiChatRoom } from "@shyne/shared/api";

export const ChatRepository = {
  async startDirect(person: uuid, actingOrganization: uuid | null): Promise<ApiChatRoom> {
    return api.chatRooms.startDirect({ person, ...(actingOrganization === null ? {} : { actingOrganization }) });
  },

  async markRead(roomId: uuid): Promise<ApiChatRoom> {
    return api.chatRooms.markRead(roomId);
  },

  async listRooms(): Promise<ApiChatRoom[]> {
    return (await api.chatRooms.list()).items;
  },

  async roomOfAppointment(appointmentId: uuid): Promise<ApiChatRoom | null> {
    try {
      return await api.chatRooms.ofAppointment(appointmentId);
    } catch (error) {
      if (error instanceof ApiRequestError && error.status === 404) return null;
      throw error;
    }
  },

  async members(roomId: uuid): Promise<ChatMember[]> {
    return (await api.chatRooms.members(roomId)).items;
  },

  async contacts(actingOrganization: uuid): Promise<ChatContact[]> {
    return (await api.chatRooms.contacts({ actingOrganization })).items;
  },

  async addMember(roomId: uuid, person: uuid, actingOrganization: uuid | null): Promise<ChatMemberAddition> {
    return api.chatRooms.addMember(roomId, { person, ...(actingOrganization === null ? {} : { actingOrganization }) });
  },
};
